import { connect } from 'react-redux';
import { useState, useRef, useEffect } from 'react';
import Popover from '@mui/material/Popover';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import './FilterButtons.css';
import { useNavigate } from 'react-router-dom';
import { SERVICE_STATUS } from '../../constants';

function FilterButtons({ projectList, pro, env, status, servicetype }) {
  const navigate = useNavigate();
  const [anchorElProj, setAnchorElProj] = useState(null);
  const [anchorElEnvt, setAnchorElEnvt] = useState(null);
  const [anchorElStat, setAnchorElStat] = useState(null);
  const [anchorElService, setAnchorElService] = useState(null);
  const [appliedFilter, setAppliedFilter] = useState({
    project: {},
    env: {},
    status: {},
    stype: {},
  });

  var envs = {};
  var statu = {};
  var project = {};
  var stype = {};
  for (let index = 0; index <= env?.length - 1; index++) {
    const element = env[index];
    envs[element] = true;
  }
  for (let index = 0; index <= pro?.length - 1; index++) {
    const element = pro[index];
    project[element] = true;
  }
  for (let index = 0; index <= status?.length - 1; index++) {
    const element = status[index];
    statu[element] = true;
  }
  for (let index = 0; index <= servicetype?.length - 1; index++) {
    const element = servicetype[index];
    stype[element] = true;
  }
  const muistyles = {
    '& .MuiFormControlLabel-root': {
      height: '35px',
    },
  };
  useEffect(() => {
    setAppliedFilter((state) => ({
      ...state,
      project: project,
      env: envs,
      status: statu,
      stype: stype,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [env, pro, status, servicetype]);

  const projectRef = useRef();
  const environmentRef = useRef();
  const statusRef = useRef();
  const servicetypeRef = useRef();

  const handleClickProj = (event) => {
    setAnchorElProj(event.currentTarget);
  };

  const handleCloseProj = () => {
    setAnchorElProj(null);
  };

  const handleClickEnvt = (event) => {
    setAnchorElEnvt(event.currentTarget);
  };

  const handleCloseEnvt = () => {
    setAnchorElEnvt(null);
  };
  const handleClickService = (event) => {
    setAnchorElService(event.currentTarget);
  };

  const handleCloseService = () => {
    setAnchorElService(null);
  };
  const handleClickStat = (event) => {
    setAnchorElStat(event.currentTarget);
  };

  const handleCloseStat = () => {
    setAnchorElStat(null);
  };

  const checkChangeHandler = (source, option) => {
    setAppliedFilter((prev) => {
      const curr = { ...prev };
      if (!prev[source][option]) curr[source][option] = true;
      else delete curr[source][option];
      return curr;
    });
  };

  const clearFilter = (source) => {
    setAppliedFilter((prev) => ({
      ...prev,
      [source]: {},
    }));
    fetchListHelper(source);
  };

  const applyFilter = (source) => {
    fetchListHelper();
  };
  const fetchListHelper = (source) => {
    const filters = { ...appliedFilter };
    if (Object.keys(filters.env)?.length === 0) delete filters.env;
    if (Object.keys(filters.project)?.length === 0) delete filters.project;
    if (Object.keys(filters.status)?.length === 0) delete filters.status;
    if (Object.keys(filters.stype)?.length === 0) delete filters.stype;
    const payload = {};
    for (let key in filters) {
      payload[key] = Object.keys(filters[key]);
    }

    // to convert status to integer
    if (filters.status) {
      const arr = [];
      filters.status[SERVICE_STATUS.SERVICE_UP] && arr.push(SERVICE_STATUS.SERVICE_UP);
      filters.status[SERVICE_STATUS.SERVICE_DOWN] && arr.push(SERVICE_STATUS.SERVICE_DOWN);
      payload.status = arr;
    }
    if (payload[source]) delete payload[source];

    function encodeQuery(data) {
      let query = '';
      for (let d in data) query += encodeURIComponent(d) + '=' + encodeURIComponent(data[d]) + '&';
      return query.slice(0, -1);
    }
    navigate('?' + encodeQuery(payload));
  };

  const openProj = Boolean(anchorElProj);
  const openEnvt = Boolean(anchorElEnvt);
  const openStat = Boolean(anchorElStat);
  const openService = Boolean(anchorElService);

  return (
    <div className="upperButtonGroup">
      <div className="upperButton">
        <button variant="outlined" onClick={handleClickProj}>
          Projects
        </button>
        <Popover
          sx={muistyles}
          id="project-popover"
          open={openProj}
          anchorEl={anchorElProj}
          onClose={handleCloseProj}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <div className="outerDiv">
            <div className="formcont">
              <FormGroup ref={projectRef}>
                {projectList?.map((proj) => (
                  <FormControlLabel
                    key={proj?.id}
                    control={
                      <Checkbox
                        checked={appliedFilter?.project[proj?.id] ?? false}
                        onChange={() => checkChangeHandler('project', proj?.id)}
                      />
                    }
                    sx={{ height: 45 }}
                    label={proj?.title}
                  />
                ))}
              </FormGroup>
            </div>
            <div className="bottomButton">
              <span className="clearbutton" id="clear">
                <button onClick={() => clearFilter('project')}>Clear</button>
              </span>
              <span className="applybutton">
                <button onClick={() => applyFilter('project')}>Apply</button>
              </span>
            </div>
          </div>
        </Popover>
      </div>
      <div className="upperButton">
        <button aria-describedby="env-popover" variant="outlined" onClick={handleClickEnvt}>
          Environment
        </button>
        <Popover
          sx={muistyles}
          id="env-popover"
          open={openEnvt}
          anchorEl={anchorElEnvt}
          onClose={handleCloseEnvt}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <div className="outerDiv">
            <div className="formcont">
              <FormGroup ref={environmentRef}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={appliedFilter?.env?.dev ?? false}
                      onChange={() => checkChangeHandler('env', 'dev')}
                    />
                  }
                  label="Dev"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={appliedFilter?.env?.stg ?? false}
                      onChange={() => checkChangeHandler('env', 'stg')}
                    />
                  }
                  label="Stg"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={appliedFilter?.env?.prod ?? false}
                      onChange={() => checkChangeHandler('env', 'prod')}
                    />
                  }
                  label="Prod"
                />
              </FormGroup>
            </div>
            <div className="bottomButton">
              <span className="clearbutton">
                <button onClick={() => clearFilter('env')}>Clear</button>
              </span>
              <span className="applybutton">
                <button onClick={() => applyFilter('env')}>Apply</button>
              </span>
            </div>
          </div>
        </Popover>
      </div>
      <div className="upperButton">
        <button aria-describedby="stat-popover" variant="outlined" onClick={handleClickStat}>
          Status
        </button>
        <Popover
          sx={muistyles}
          id="stat-popover"
          open={openStat}
          anchorEl={anchorElStat}
          onClose={handleCloseStat}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <div className="outerDiv">
            <div className="formcont">
              <FormGroup ref={statusRef}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={appliedFilter.status[SERVICE_STATUS.SERVICE_UP] ?? false}
                      onChange={() => checkChangeHandler('status', SERVICE_STATUS.SERVICE_UP)}
                    />
                  }
                  label="UP"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={appliedFilter.status[SERVICE_STATUS.SERVICE_DOWN] ?? false}
                      onChange={() => checkChangeHandler('status', SERVICE_STATUS.SERVICE_DOWN)}
                    />
                  }
                  label="DOWN"
                />
              </FormGroup>
            </div>
            <div className="bottomButton">
              <span className="clearbutton">
                <button onClick={() => clearFilter('status')}>Clear</button>
              </span>
              <span className="applybutton">
                <button onClick={() => applyFilter('status')}>Apply</button>
              </span>
            </div>
          </div>
        </Popover>
      </div>
      <div className="upperButton">
        <button aria-describedby="env-popover" variant="outlined" onClick={handleClickService}>
          Service Type
        </button>
        <Popover
          sx={muistyles}
          id="env-popover"
          open={openService}
          anchorEl={anchorElService}
          onClose={handleCloseService}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <div className="outerDiv">
            <div className="formcont">
              <FormGroup ref={servicetypeRef}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={appliedFilter?.stype?.es ?? false}
                      onChange={() => checkChangeHandler('stype', 'es')}
                    />
                  }
                  label="Elastic"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={appliedFilter?.stype?.worker ?? false}
                      onChange={() => checkChangeHandler('stype', 'worker')}
                    />
                  }
                  label="Worker"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={appliedFilter?.stype?.kafka ?? false}
                      onChange={() => checkChangeHandler('stype', 'kafka')}
                    />
                  }
                  label="Kafka"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={appliedFilter?.stype?.url ?? false}
                      onChange={() => checkChangeHandler('stype', 'url')}
                    />
                  }
                  label="Url"
                />
              </FormGroup>
            </div>
            <div className="bottomButton">
              <span className="clearbutton">
                <button onClick={() => clearFilter('stype')}>Clear</button>
              </span>
              <span className="applybutton">
                <button onClick={() => applyFilter('stype')}>Apply</button>
              </span>
            </div>
          </div>
        </Popover>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  projectList: state.app.projectList,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FilterButtons);
